import type { CustomerLoginRouterScope } from "@Front/Components/Layouts/Login/helpers/customerLoginRouterScope";
import { useLoginPasswordRecoveryCallbacks } from "./useLoginPasswordRecoveryCallbacks";
import type { CustomerLoginState } from "@Front/Components/Layouts/Login/hooks/helpers/loginStateHook";

export function useLoginPasswordRecoveryPart(params: {
	loginScope: CustomerLoginRouterScope;
	loginState: CustomerLoginState;
}): {
	onPasswordForgotClicked: () => void;
	onSendAnotherCode: () => void;
} {
	return useLoginPasswordRecoveryCallbacks({
		loginScope: params.loginScope,
		loginState: params.loginState,
	});
}
